export function emptyQuestionAnswer() {
    return {
        answerSnippet: '',
        documentId: {
            contentIdKey: '',
            contentIdValue: '',
        },
        question: '',
        relatedQuestions: [],
        score: 0,
    };
}
export function getSearchInitialState() {
    return {
        response: {
            results: [],
            searchUid: '',
            totalCountFiltered: 0,
            facets: [],
            generateAutomaticFacets: { facets: [] },
            queryCorrections: [],
            triggers: [],
            questionAnswer: emptyQuestionAnswer(),
            pipeline: '',
            splitTestRun: '',
            termsToHighlight: {},
            phrasesToHighlight: {},
            extendedResults: {},
        },
        duration: 0,
        queryExecuted: '',
        error: null,
        automaticallyCorrected: false,
        isLoading: false,
        results: [],
        searchResponseId: '',
        requestId: '',
        questionAnswer: emptyQuestionAnswer(),
        extendedResults: {},
        searchAction: undefined,
    };
}
